(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casa-cstm-clove-on-cameron-membership"] && !Shopify.designMode) return;
  try {
    
  function initCloveOnCameronMembership(scope) {
    scope.querySelectorAll('[data-clove-on-cameron-membership]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const buttons = root.querySelectorAll('[data-faq-button]');
      const setOpen = (button, open) => {
        button.setAttribute('aria-expanded', String(open));
        root.querySelector('#' + CSS.escape(button.getAttribute('aria-controls'))).hidden = !open;
        button.querySelector('[data-faq-symbol]').textContent = open ? '−' : '+';
      };
      buttons.forEach((button) => {
        setOpen(button, button.dataset.initialOpen === 'true');
        button.addEventListener('click', () => {
          const open = button.getAttribute('aria-expanded') !== 'true';
          buttons.forEach((other) => setOpen(other, other === button && open));
        });
      });
    });
  }
  initCloveOnCameronMembership(document);
  document.addEventListener('shopify:section:load', () => initCloveOnCameronMembership(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
